<template>
  <v-layout pa-3 column align-center>
    <v-flex>
      <ul class="v-pagination">
        <li class="page-item">
          <v-btn
            class="mx-1"
            :disabled="isOnFirstPage"
            @click.prevent="loadPage(1)"
            flat
            icon
          >
            <v-icon>mdi-chevron-double-left</v-icon>
          </v-btn>
        </li>

        <li class="page-item">
          <v-btn
            class="mx-1"
            :disabled="isOnFirstPage"
            @click.prevent="loadPage('prev')"
            flat
            icon
          >
            <v-icon>chevron_left</v-icon>
          </v-btn>
        </li>

        <template v-if="notEnoughPages">
          <li class="page-item hidden-sm-and-down" v-for="n in totalPage" v-bind:key="n">
            <v-btn
              class="mx-1"
              :class="{'accent': isCurrentPage(n)}"
              :dark="isCurrentPage(n)"
              :fab="isCurrentPage(n)"
              :icon="!isCurrentPage(n)"
              @click.prevent="loadPage(n)"
              small
            >{{n}}</v-btn>
          </li>
        </template>

        <template v-else>
          <li class="page-item hidden-sm-and-down" v-for="n in windowSize" v-bind:key="n">
            <v-btn
              class="mx-1"
              :class="{'accent': isCurrentPage(windowStart+n-1)}"
              :dark="isCurrentPage(windowStart + n -1)"
              :fab="isCurrentPage(windowStart + n -1)"
              :icon="!isCurrentPage(windowStart + n -1)"
              @click.prevent="loadPage(windowStart+n-1)"
              small
            >{{windowStart+n-1}}</v-btn>
          </li>
        </template>

        <li class="page-item">
          <v-btn
            class="mx-1"
            :disabled="isOnLastPage"
            @click.prevent="loadPage('next')"
            flat
            icon
          >
            <v-icon>chevron_right</v-icon>
          </v-btn>
        </li>

        <li class="page-item">
          <v-btn
            class="mx-1"
            :disabled="isOnLastPage"
            @click.prevent="loadPage(totalPage)"
            flat
            icon
          >
            <v-icon>mdi-chevron-double-right</v-icon>
          </v-btn>
        </li>
      </ul>
    </v-flex>
  </v-layout>
</template>

<script>
import VuetablePaginationMixin from 'vuetable-2/src/components/VuetablePaginationMixin.vue';

export default {
  mixins: [VuetablePaginationMixin],
};
</script>

<style>
.disabled {
  pointer-events: none!important;
  cursor: not-allowed !important;
  color: #868e96 !important;
}

.disabled .v-icon {
  color: #eeeeee !important;
}
</style>
